import apiInstance from "../Api/ApiInstance";

export async function referralHistoryService(ip, referralCode) {
  return await apiInstance.post(`api/official-site/referral-history`, {
    ip,
    referralCode,
  });
}
